import { Icon, IconName, Text } from "@zapier/design-system";
import Link from "next/link";
import styles from "./NavToggle.module.css";

type Link = {
  id: string;
  label: string;
  icon: string;
  href: string;
};

type NavToggleProps = {
  links: Link[];
  currentPath: string;
  isDisabled?: boolean;
};

export function NavToggle({ links, currentPath }: NavToggleProps) {
  return (
    <div className={styles.linkGroup}>
      {links.map((link) => {
        const isSelected = link.href === currentPath;
        return (
          <Link
            key={link.id}
            className={`${styles.link} ${isSelected ? styles.active : styles.link}`}
            href={link.href}
          >
            <Icon name={link.icon as IconName} size={18} />
            <Text type="Body2" color="inherit">
              {link.label}
            </Text>
          </Link>
        );
      })}
    </div>
  );
}
